// app/(routes)/contact/referralSource.ts

export interface ReferralSearchParams {
  get(name: string): string | null;
}

export function getReferralSource(
  searchParams: ReferralSearchParams,
  fallback = "direct",
): string {
  return (
    searchParams.get("source") ||
    searchParams.get("utm_source") ||
    searchParams.get("ref") ||
    fallback
  );
}
